<template>
  <div>
    <div v-for="(item, index) in items" :key="item.icon + index">
      <v-icon v-if="item.icon" class="me-3" data-testid="icons-list-icon">
        {{ item.icon }}</v-icon
      >
      <span v-else class="pa-4"></span>
      <span
        v-html="sanitizeContent(item.text || '')"
        data-testid="icons-list-content"
        class="body1"
        data-private
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconList',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    items() {
      return this.data?.items ?? []
    },
  },

  methods: {
    sanitizeContent(content) {
      return this.$sanitize(content)
    },
  },
}
</script>
